import * as React from 'react';
import { hospitalHeader, UserSelectBody, Type } from './UserListField';
import 'react-bootstrap';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/user_select.css';
import '../css/locomo.css';
import '../css/calendar.css';
import '../css/print.css';
import * as Header from '../constants/Header';
import { Dialog, Button, Form, Input } from 'element-react';
import { Hospital } from '@src/interfaces';
import Back from './common/Back';

interface HospitalListProps extends React.Props<{}> {
  moffAPI: any;
  moffAPIActions: any;
  headerActions?: any;
}

interface ListState {
  showAddDialog: boolean;
  form: Hospital;
}

class HospitalList extends React.Component<HospitalListProps, ListState> {
  constructor (props: any) {
    super(props);
    this.state = {
      showAddDialog: false,
      form: {
        name: ''
      }
    };
  }

  onChange(key: string, value: any) {
    this.state.form[key] = value;
    this.forceUpdate();
  }

  onSubmit() {
    this.props.moffAPIActions.postAddHospital(this.state.form.name);
    this.setState({ showAddDialog: false });
  }

  componentWillMount() {
    document.title = '医療機関一覧画面';

    this.props.headerActions.setPage(Header.HOSPITAL_LIST);

    // Action
    this.props.moffAPIActions.getAllHospitals();
  }

  render () {
    return (
    <div>
      <Dialog
        title="医療機関追加"
        size="tiny"
        visible={this.state.showAddDialog}
        onCancel={() => this.setState({ showAddDialog: false })}
        lockScroll={false}
      >
        <Dialog.Body>
          <Form model={this.state.form} labelWidth="120">
            <Form.Item label="医療機関名">
              <Input value={this.state.form.name} onChange={this.onChange.bind(this, 'name')} />
            </Form.Item>
          </Form>
        </Dialog.Body>
        <Dialog.Footer className="dialog-footer">
        <Button onClick={() => this.setState({ showAddDialog: false })}>キャンセル</Button>
          <Button type="primary" onClick={() => this.onSubmit()}>医療機関登録</Button>
        </Dialog.Footer>
      </Dialog>
      <Back />
      <div className="btnStyle02">
        <Button onClick={() => this.setState({ showAddDialog: true })}>医療機関登録</Button>
      </div>
        <div id="userlist">
          <table className="tblStyle01">
            <thead>
              <tr>
                {hospitalHeader}
              </tr>
            </thead>
            <tbody>
            <UserSelectBody
              type={Type.Hospital}
              hospitals={this.props.moffAPI.hospitals}
              checkedUserIds={[]}
              moffAPI={this.props.moffAPI}
              moffAPIActions={this.props.moffAPIActions}
              download={false}
            />
            </tbody>
          </table>
        </div>
        <style type="text/css">
          {'#wrapper .contentIn { padding-top: 50px;text-align: left; }'}
          {'.btnStyle02 { margin-bottom: 16px;text-align: left;max-width: 180px; }'}
        </style>
    </div>
    );
  }

}
export default HospitalList;



// WEBPACK FOOTER //
// ./src/components/HospitalList.tsx